<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
// import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import Swal from "sweetalert2";

export default {
    page: {
        title: "Customer Blacklist & Active Contract",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Customer Blacklist & Active Contract",
            items: [
                {
                text: "Customer Blacklist & Active Contract",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            customerBlacklist:[],
            customerActiveContract:[],
            ButtonSeen:true,
            programList:[],
            nric:'',
            dtKey:0,
            loading:false,
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY, H:mm:ss')
            }
        },

        submitForm(e)
        {
            this.$router.push('/customer/customer-blacklist-check/'+this.nric);
            this.ButtonSeen=true;
            this.searchCustomerBlacklist(this.nric);
            e.preventDefault()
        },

        searchCustomerBlacklist(nric){
            console.log('aaa');
            this.loading = true;
            const posting_ = {                
                nric: nric
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'customer/blacklist/check', posting_)
            .then(response => {
                if (response) {
                    this.customerBlacklist = response.data;
                    this.dtKey +=1;
                    console.log(this.customerBlacklist);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'customer/active/check', posting_)
            .then(response => {
                if (response) {
                    this.customerActiveContract = response.data;
                    this.dtKey +=1;
                    console.log(this.customerActiveContract);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
            this.loading = false;
        },

        resetForm: function () { 
            this.nric = '';
        },

        deleteBlacklist(id){
            this.loading = true;
            Swal.fire({
                title: "Are you sure you want to delete this blacklist?",
                icon: "info",
                showCancelButton: true,
                cancelButtonColor: "#f46a6a",
                confirmButtonColor: "#34c38f",
                confirmButtonText: "Yes, Delete this blacklist",
            }).then((result) => {
                if (result.value) {
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.get(process.env.VUE_APP_API_BASEURL+'customer/blacklist/delete/'+id)
                    .then(response => {
                        // console.log(response);
                        if (response.status == 201||response.status == 200) {
                            Swal.fire({
                                title:"Customer blacklist deleted!", 
                                icon:"success",
                            })
                            this.$router.push('/customer/customer-blacklist-check/'+this.nric);
                            this.searchCustomerBlacklist(this.nric);
                        } 
                        else {
                            Swal.fire({
                                title:"Customer blacklist failed to delete!", 
                                icon:"warning",
                            })
                        }
                    }).catch(function (error) {                    
                        Swal.fire({
                            title:error.response.data.message, 
                            icon:"warning",
                        })
                    });
                }
            });
            
            this.loading = false;
            
        },

        deleteActiveContract(id){
            this.loading = true;
            Swal.fire({
                title: "Are you sure you want to delete this active customer?",
                icon: "info",
                showCancelButton: true,
                cancelButtonColor: "#f46a6a",
                confirmButtonColor: "#34c38f",
                confirmButtonText: "Yes, Delete this active customer",
            }).then((result) => {
                if (result.value) {
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.get(process.env.VUE_APP_API_BASEURL+'customer/active/delete/'+ id)
                    .then(response => {
                        // console.log(response);
                        if (response.status == 201||response.status == 200) {
                            Swal.fire({
                                title:"Active customer deleted!", 
                                icon:"success",
                            })
                            this.$router.push('/customer/customer-blacklist-check/'+this.nric);
                            this.searchCustomerBlacklist(this.nric);
                        } 
                        else {
                            Swal.fire({
                                title:"Active Customer failed to delete!", 
                                icon:"warning",
                            })
                        }
                    }).catch(function (error) {                    
                        Swal.fire({
                            title:error.response.data.message, 
                            icon:"warning",
                        })
                    });
                }
            });
            this.loading = false;
        },
    },

    components: {
        Layout,
        PageHeader,
        // DataTable,
        //flatPickr,
    },

    mounted() {
        if(typeof this.$route.params.nric !== 'undefined'){
            this.nric = this.$route.params.nric;
            this.searchCustomerBlacklist(this.nric);
        }
    },
    
};
// require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="card">
            <div class="card-body border-bottom-dashed border-bottom">
                <form @submit="submitForm">
                    <div class="row g-3 justify-content-end mt-2">
                        <!--div class="col-xl-7 mb-4 ">
                            <div class="search-box">
                                <input type="text" class="form-control search"
                                placeholder="Search for Customer Name, Email Address" v-model="key_search"/>
                                <i class="ri-search-line search-icon"></i>
                            </div>
                        </div-->
                        <div class="col-xl-12 mb-4 ">
                            <div class="search-box">
                                <input type="text" class="form-control search"
                                placeholder="Search for Customer NRIC" v-model="nric"/>
                                <i class="ri-search-line search-icon"></i>
                            </div>
                        </div>
                    </div>
                    <div class="row g-3 justify-content-end">
                        <div class="col-xl-2">
                            <div>
                                <button type="submit" class="btn btn-primary w-100">
                                    <i class="ri-equalizer-fill me-2 align-bottom"></i>Search
                                </button>
                            </div>
                        </div>
                        <div class="col-xl-2">
                            <div>
                                <button @click='resetForm' class="btn btn-danger w-100">
                                    <i class="ri-refresh-fill me-2 align-bottom"></i>Reset
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="card-body" v-if="!loading">
                <div class="live-preview mb-4 border-bottom-dashed border-bottom">
                    <div class="row align-items-center g-12 mb-4">
                        <div class="col-lg-12">
                            <div>
                                <h5 class="card-title mb-0">Blacklist</h5>
                            </div>
       
                            <div>
                                <div class="table-responsive">
                                <table :options="{lengthChange: false,searching: false, ordering: false, bInfo: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example">  
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>#.</th>         
                                            <th scope="col">Customer Name</th>           
                                            <th scope="col">NRIC</th>           
                                            <th scope="col">Blacklist Reason</th>           
                                            <th scope="col">Delete</th>                                                      
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in customerBlacklist" :key="index" class="content">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ item.CustName }}</td>                               
                                            <td>{{ item.ICBRNo }}</td>
                                            <td>{{ item.Blacklist_Reason }}</td>
                                            <td><a href="#" @click="deleteBlacklist(item.id)">Delete</a></td>                                             
                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div>
                                <h5 class="card-title mb-0">Active Contract</h5>
                            </div>
                            <div>
                                <div class="table-responsive">
                                <table :options="{lengthChange: false,searching: false, ordering: false, bInfo: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example">  
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>#.</th>
                                            <th scope="col">Contract Number</th>           
                                            <th scope="col">Order Number</th>           
                                            <th scope="col">Customer Name</th>           
                                            <th scope="col">NRIC</th>
                                            <th scope="col">DOB</th>           
                                            <th scope="col">Customer Email</th>
                                            <th scope="col">Delete</th>
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in customerActiveContract" :key="index" class="content">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ item.contract_no }}</td>
                                            <td>{{ item.order_no }}</td>
                                            <td>{{ item.customer_name }}</td>
                                            <td>{{ item.nric_or_pass }}</td>
                                            <td>{{ item.dob }}</td>
                                            <td>{{ item.email }}</td>
                                            <td><a href="#" @click="deleteActiveContract(item.id)">Delete</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>